export default {
    props: {
        value: Boolean,
        inputclass: {
            type: String,
            default: ''
        },
    },
    name: 'InputCheck',
    data() {
        return {
        };
    },
};